/**
 * GuestStaffInfoCard — banner discreto exibido no topo do Dashboard para usuários
 * que acessam um evento como Convidado ou Staff (assinatura derivada do proprietário).
 *
 * Pra que serve?
 * 1) Deixa explícito que o acesso é DERIVADO (transparência → menos dúvidas no suporte)
 * 2) Cria um caminho de conversão pra esses usuários virarem clientes próprios
 *    da Liventy (com OUTRO e-mail, conforme regra do produto).
 *
 * Quando aparece?
 * Quando isStaffAccount === true no DashboardPage (user_type=colaborador && !account_owner).
 */
import React from "react";
import { Users, Briefcase, ArrowRight, Sparkles } from "lucide-react";

export default function GuestStaffInfoCard({ user, navigate }) {
  // Heurística simples para inferir o perfil exibido: por enquanto todos os
  // colaboradores caem em "Usuário" (descrição/nome). Quando a próxima onda
  // mapear convidado/staff explicitamente no doc wedding_users.profile, basta
  // ler user.profile aqui.
  const profile = user?.profile === "staff" ? "Staff" : "Usuário Convidado";
  const Icon = user?.profile === "staff" ? Briefcase : Users;

  return (
    <div
      className="relative overflow-hidden rounded-2xl border border-zinc-200/70 bg-gradient-to-br from-white via-white to-violet-50/40 p-4 sm:p-5"
      data-testid="guest-staff-info-card"
    >
      <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-gradient-to-br from-violet-200/60 to-rose-200/40 blur-2xl pointer-events-none" />
      <div className="relative flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-xl bg-violet-100/80 flex items-center justify-center flex-shrink-0 ring-1 ring-violet-200/60">
            <Icon size={18} className="text-violet-600" strokeWidth={2} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[12.5px] text-zinc-500 leading-tight">Você está acessando este evento como</p>
            <p className="text-[15px] font-semibold text-zinc-900 mt-0.5 tracking-tight" data-testid="guest-staff-profile-label">
              {profile}
            </p>
            <p className="text-[11.5px] text-zinc-500 mt-1.5 leading-relaxed">
              Seu acesso foi concedido pelo proprietário do evento. Deseja utilizar a Liventy para organizar seus próprios eventos?
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => navigate?.("/get-started")}
          className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-zinc-900 text-white text-[12.5px] font-semibold hover:bg-zinc-800 active:scale-[0.98] transition-all flex-shrink-0 self-start sm:self-auto"
          data-testid="guest-staff-create-account-btn"
        >
          <Sparkles size={13} />
          Criar Nova Conta
          <ArrowRight size={13} />
        </button>
      </div>
      <p className="relative text-[10.5px] text-zinc-400 mt-3 italic">
        O novo cadastro deve utilizar um endereço de e-mail diferente do atualmente vinculado a este evento.
      </p>
    </div>
  );
}
